import React from "react";
import "./subscriptionBody.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Topbar from "../Global/topbar";
import SubscriptionBodyForm from "./SubscriptionBodyForm";

export default function SubscriptionBody() {
  const navigate = useNavigate();

  const notify = () => {
    navigate("/admin/subscription");
  };

  return (
    <div className="create-main-subscription">
      <div className="container-subscription">
        <Topbar />
        <div className="creat-mid">
          <div className="back">
            {" "}
            <button onClick={notify} className="logout">
              {" "}
              <ArrowBackIcon style={{ fontSize: "2rem" }} />
            </button>
            <h1> New Subscription</h1>
          </div>
          <div>
            <Link to="" style={{ display: "none" }}>
              Dashboard
            </Link>{" "}
            <Link to="/admin/subscription">Subscriptions List</Link> &#62;{" "}
            <Link to="/admin/subscription/create_subscription">New Subscription</Link>
          </div>
        </div>
        <SubscriptionBodyForm />
      </div>
    </div>
  );
}
